export default "__VITE_ASSET__IU6ssYMz__"